import Navbar from "../navbar/Navbar";
import PaymentSidebar from "../sidebar/PaymentSidebar";

function PaymentWrapper({ children, sidebarOpen, toggleSidebar }) {
  return (
    <>
      <Navbar sidebarOpen={sidebarOpen} toggleSidebar={toggleSidebar} />
      {children}
      <PaymentSidebar sidebarOpen={sidebarOpen} toggleSidebar={toggleSidebar} />
    </>
  );
}

export default PaymentWrapper;
